import * as React from "react";
import classNames from "classnames";
import Loader from "react-content-loader";
import { useAuth } from "hooks";
import { Content } from "components";
import styles from "./ContentLoader.module.css";

export interface ContentLoaderProps {
  width?: number;
  height?: number;
  dark?: boolean;
  viewBox?: string;
  className?: string;
  withContent?: boolean;
  children?: React.ReactNode;
}

const ContentLoader: React.FC<ContentLoaderProps> = ({
  className,
  dark = false,
  withContent = false,
  ...rest
}) => {
  const [auth] = useAuth();
  const { accTheme } = auth.data.user;

  return React.createElement(
    (withContent ? Content : React.Fragment) as any,
    null,
    <Loader
      {...rest}
      gradientRatio={0.8}
      className={classNames(styles.wrapper, className)}
      backgroundColor={
        (accTheme === "high-contrast" && "var(--basic-400)") ||
        (dark ? "var(--basic-300)" : "var(--basic-200)")
      }
      foregroundColor={
        (accTheme !== "high-contrast" && "var(--basic-100)") ||
        (dark ? "var(--basic-200)" : "var(--basic-100)")
      }
    />,
  );
};

export default ContentLoader;
